<script lang='ts'>
  import { afterUpdate, onMount } from 'svelte'
  import Player from './components/Player.svelte'

  let streams = []
  let showAutoplayPrompt = false;
  let players = []
  let orientation = {}
  let containers = {}
  let controls;
  let fullscreen = null;

  onMount(()=> {
    const load = () => {
      fetch('https://stopgame.ru/ajax/streams/get')
        .then(response => response.json())
        .then(data => {
          streams = data.response.sort()
          if (fullscreen && !streams.includes(fullscreen)) {
            fullscreen = null
          }
          sendStreams()
        })
        .finally(() => {
          setTimeout(load, 1000)
        })
    }
    load();

    const video = document.createElement('video');
    const promise = video.play();

    if (promise !== undefined) {
      promise.then(_ => {
        // Autoplay started!
      }).catch(() => {
        // Autoplay was prevented.
        // Show a "Play" button so that user can start playback.
        showAutoplayPrompt = true
      });
    }

    const sendStreams = () => {
      if (controls) {
        const newStreams = streams.map((stream) => {
          return {
            name: stream,
            muted: players[stream]?.getMute() ?? true,
            fullscreen: fullscreen === stream
          }
        })
        controls.postMessage({
          type: 'streams',
          streams: newStreams
        })
      }
    }

    window.addEventListener('beforeunload', () => {
      if (controls) {
        controls.close()
      }
    })

    const openWindow = async () => {
      if (controls) {
          controls.close()
      }
      let left = 200;

      if ('getScreenDetails' in window) {
        try {
          const details = await window.getScreenDetails()
          if (details.screens.length > 1) {
            for (let i = 0; i < details.screens.length; i++) {
              if (details.screens[i].left !== details.currentScreen.left) {
                left += details.screens[i].left;
                break;
              }
            }
          }
        } catch (e) {
          console.error(e)
          // Do nothing
        }
      }

      controls = window.open('/controls', '_blank', `popup=yes,resizable=yes,scrollbars=yes,width=500,height=500,left=${left},top=200`);
    }

    openWindow()

    window.addEventListener('keydown', async (e) => {
      if (e.key === 'F1') {
        e.preventDefault();
        e.stopPropagation();
        openWindow();
      }
    })

    window.onmessage = (e) => {
      if (e.data === 'getStreams') {
        sendStreams();
      } else if (e.data.type === 'unmute') {
        for (let key in players) {
          players[key]?.setMute(key !== e.data.stream)
        }
        sendStreams();
      } else if (e.data.type === 'mute') {
        players[e.data.stream]?.setMute(true)
        sendStreams();
      } else if (e.data.type === 'fullscreen') {
        fullscreen = e.data.fullscreen
        for (let key in players) {
          players[key]?.setMute(key !== e.data.stream)
        }
        sendStreams();
      }
    }
  })
  afterUpdate(() => {
    for (let key in containers) {
      if (containers[key]) {
        const width = containers[key].offsetWidth
        const height = containers[key].offsetHeight
        if (width / height <= 1.77) {
          orientation[key] = 'portrait'
        } else {
          orientation[key] = 'landscape'
        }
      }
    }
  })
</script>

<main class='length-{streams.length}'
  class:fullscreen={fullscreen !== null}
  style='--items-count: {streams.length}'>
  {#each streams as stream, key (`${stream}`)}
    <div
      class='stream'
      class:stream-sound={!players[stream]?.getMute()}
      class:stream-fullscreen={fullscreen === stream}
      class:stream-portrait={orientation[stream] === 'portrait'}
      class:stream-landscape={orientation[stream] === 'landscape'}
      bind:this={containers[stream]}
    >
      <div class="stream-container">
        <!--<h1 class='stream-title'>{stream}</h1>-->
        <Player bind:this={players[stream]} stream={stream} />
      </div>
    </div>
  {/each}
  {#if streams.length === 0}
    <div class='autoplay-prompt'>
      <h1>Нет стримов</h1>
    </div>
  {/if}
  {#if showAutoplayPrompt}
    <div class='autoplay-prompt'>
      <h1>Кликни по кнопке, чтобы браузер разрешил сайту проигрывать звук из стримов</h1>
      <button on:click={() => {
        for (let key in players) {
          const player = players[key]
          player.play()
        }
        showAutoplayPrompt = false
      }}>Кнопку нажал — автопроиграл!</button>
    </div>
  {/if}
</main>

<style>
  :global(html,body) {
    padding: 0;
    margin: 0;
  }

  :global(body) {
    background: url("https://stopgame.ru/img/backdrop.png");
    /*background: url("/bg.png");*/
    background-size: cover;
    color: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  main {
    display: grid;
    column-gap: 16px;
    row-gap: 16px;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 16px);
    padding: 8px;
    grid-template-columns: 1fr;
  }

  main.length-2 {
    grid-template-columns: 1fr 1fr;
  }

  main.length-3,
  main.length-4 {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  main.length-5,
  main.length-6 {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  main.length-7,
  main.length-8,
  main.length-9 {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }

  main.fullscreen {
    grid-template-columns: repeat(calc(var(--items-count) - 1), 1fr);
    grid-template-rows: 1fr minmax(auto, 250px);
  }

  main.length-1.fullscreen {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .stream {
    position: relative;
    flex-grow: 1;
    overflow: hidden;
    height: 100%;
    width: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
  }

  .stream-fullscreen {
    grid-row: 1/2;
    grid-column: 1/-1;
  }

  .stream-container {
    position: relative;
    aspect-ratio: 16/9;
    border-radius: 8px;
  }

  .stream-sound .stream-container {
    border: 2px solid green;
  }

  .stream-portrait .stream-container {
    width: 100%;
  }

  .stream-landscape .stream-container {
    height: 100%;
  }

  h1 {
    font-family: Rubik, sans-serif;
    font-weight: 500;
  }

  /*h1.stream-title {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
    margin: 0;
    background: rgb(0 0 0/.5);
    border-radius: 8px;
    padding: 8px 16px;
  }*/

  /*main.fullscreen .stream:not(.stream-fullscreen) h1.stream-title {
    font-size: 20px;
  }*/

  .autoplay-prompt {
    position: fixed;
    background: url("https://stopgame.ru/img/backdrop.png");
    background-size: cover;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

</style>
